<template>
  <div class="main-title" v-if="title">
    <div
      class="main-title-back bg-theme"
      v-if="$route.meta.showBack !== false"
      @click="$router.back()">
      <Icon type="ios-arrow-back" />
    </div>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([ 'title' ])
  }
}
</script>

<style lang="less" scoped>
.main-title {
  display: flex;
  align-items: center;
  height: 50px;

  &-back {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    margin-left: 10px;
    border-radius: 50%;
    font-size: 2em;
    color: #ffffff;
    cursor: pointer;
  }
  h1 {
    padding: 0 10px;
  }
}
</style>

